<div class="cookie-modal-wrapper">
  <div [@appearSlowlyAnimation] class="bottom-modal">
    <div [ngClass]="isMobile ? 'mobile-css' : 'desktop-css'" class="bottom-modal-body white-bg">
      @if (step !== 'success') {
        <h2>{{ 'emailValidation.validateEmail' | translate }}</h2>
      }

      @if (loading) {
        <div class="spinner-overlay">
          <div class="spinner"></div>
        </div>
      }

      @if (step === 'intro') {
        <div class="modal-body">
          <p>{{ 'emailValidation.sendEmail' | translate }}</p>
          <div [ngClass]="{'bottom-modal-btn-container-mobile': isMobile}" class="button-container my-4">
            <button (click)="closeModal()"
              class="btn bottom-modal-btn bottom-modal-not-accept-btn mt-2">{{ 'emailValidation.validateLater' | translate }}
            </button>
            <button (click)="sendCode()" class="btn btn-primary mt-2"
              style=" margin: 0; min-width: 12rem;">{{ 'emailValidation.sendCode' | translate | uppercase }}
            </button>
          </div>
        </div>
      }

      @if (step === 'codeSent') {
        <div class="modal-body">
          <p>{{ 'emailValidation.success.sentEmail' | translate }} {{ validationEmail }}</p>
          <p>{{ 'emailValidation.codeIsValidUntil30min' | translate }}</p>
          <p>{{ 'emailValidation.enterCode' | translate }}</p>
          <div [ngClass]="{'bottom-modal-btn-container-mobile': isMobile}" class="input-container my-4">
            <input type="text" [(ngModel)]="code"
              class="code-input"
              placeholder="{{ 'emailValidation.validationCode' | translate }}"/>
              <button class="btn btn-primary mt-2" (click)="validateCode()">
                {{ 'emailValidation.validateCode' | translate }}
              </button>
            </div>
            <p class="hint">
              {{ 'emailValidation.didNotReceiveEmail' | translate }}
              <a [routerLink]="['/settings/user-profile']"
                (click)="closeModal()">
                {{ 'emailValidation.updateEmail' | translate }}
              </a>
              {{ 'emailValidation.updateEmailLocation' | translate }}
            </p>
          </div>
        }

        @if (step === 'success') {
          <div class="modal-body">
            <p class="success">{{ 'emailValidation.success.validated' | translate }}</p>
            <div class="button-container my-4">
              <button class="btn bottom-modal-btn bottom-modal-not-accept-btn mt-2" (click)="closeModal()">
                {{ 'emailValidation.close' | translate }}
              </button>
            </div>
          </div>
        }

        @if (errorMessage) {
          <div class="error">
            {{ errorMessage | translate }}
          </div>
        }
      </div>
    </div>
  </div>
